const faqpage = () => {
	if ($(".faq-page").length) {
		// Trigger click event on first item to update content
		$('.faq-item').first().trigger('click');

		$('.multiple-items').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>',
			arrows: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: false
					},
				},
			]
		});

		$('.faq-item').click(function() {
			// Remove active class from all faq-items
			$('.faq-item').removeClass('active');
			
			// Add active class to clicked item
			$(this).addClass('active');

			// Get faq data
			const faqId = $(this).data('id');
			const faqData = window.faqData;
			const selectedFaq = faqData.find(faq => faq.id === faqId);

			// Update content for desktop view
			if ($(window).width() >= 1024) {
				$('.faq-content-item .title-faq-content').first().html(selectedFaq.title);
				$('.faq-content-item .content-faq-content').html(selectedFaq.content);
				
				// Update documents
				const documentsHtml = selectedFaq.documents.slice(0, 3).map(doc => `
					<div class="col-3">
						${doc.html}
					</div>
				`).join('');
				$('.faq-content-item .row').html(documentsHtml);
			}

			// Show modal on mobile
			if ($(window).width() < 1024) {
				$('.modal-faq, .modal-overlay').addClass('active');
				// Update modal content
				$('.modal-faq-content .title').html(selectedFaq.title);
				$('.modal-faq-content .content').html(selectedFaq.content);
				
				// Update modal documents
				const modalDocumentsHtml = selectedFaq.documents.map(doc => `
					<div class="col-12">
						${doc.html}
					</div>
				`).join('');
				$('.modal-faq-support .multiple-items').html(modalDocumentsHtml);
				
				// Reinitialize slick slider
				$('.multiple-items').slick('unslick').slick({
					slidesToShow: 4,
					slidesToScroll: 4,
					prevArrow: '<button type="button" class="slick-prev"></button>',
					nextArrow: '<button type="button" class="slick-next"></button>',
					arrows: true,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								arrows: false
							},
						},
					]
				});
			}
		});

		$('.faq-category-item').click(function() {
			window.location.href = `?category=${$(this).data('category')}`;
		});

		$('.modal-faq-header').click(function() {
			$('.modal-faq, .modal-overlay').removeClass('active');
		});

		$(window).resize(function() {
			if ($(window).width() >= 1024) {
				$('.modal-faq, .modal-overlay').removeClass('active');
			}
		});
	}
}

module.exports = faqpage
